import { Position } from "@sportactics/board-editing";

export type PositionDocument = {
  x: number;
  y: number;
};

export function convertPositionToDocument(
  position: Position,
): PositionDocument {
  return {
    x: position.x,
    y: position.y,
  };
}

export function convertDocumentToPosition(
  document: PositionDocument,
): Position {
  return new Position(document.x, document.y);
}
